module.exports = __webpack_public_path__ + "static/media/Barbaracle_gaussian2.e3454cef.png";